

const ReportModuleOthers = ({ }) => {
    return <div>
        <h2>
            Report Module Others
        </h2>
    </div>
}

export default ReportModuleOthers;